import { gql } from '@apollo/client'

export const DELETE_PLANOGRAM = gql`
  mutation SoftDeletePlanogram($input: SoftDeletePlanogramInput!) {
    softDeletePlanogram(input: $input) {
      planogram {
        dateRemoved
        status
      }
    }
  }
`
